import { MOCK_TRANSACTIONS_EN, MOCK_AVIOS_TRANSACTIONS_EN } from './locales/en/mock-transactions.js';
import { MOCK_TRANSACTIONS_EN_US, MOCK_AVIOS_TRANSACTIONS_EN_US } from './locales/en-us/mock-transactions.js';
import { MOCK_TRANSACTIONS_JA, MOCK_AVIOS_TRANSACTIONS_JA } from './locales/ja/mock-transactions.js';
import { MOCK_TRANSACTIONS_KO, MOCK_AVIOS_TRANSACTIONS_KO } from './locales/ko/mock-transactions.js';
import { MOCK_TRANSACTIONS_ZH_CN, MOCK_AVIOS_TRANSACTIONS_ZH_CN } from './locales/zh-cn/mock-transactions.js';
import { MOCK_TRANSACTIONS_ZH_TW, MOCK_AVIOS_TRANSACTIONS_ZH_TW } from './locales/zh-tw/mock-transactions.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_EN } from './locales/en/mock-cross-currency.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_EN_US } from './locales/en-us/mock-cross-currency.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_JA } from './locales/ja/mock-cross-currency.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_KO } from './locales/ko/mock-cross-currency.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_CN } from './locales/zh-cn/mock-cross-currency.js';
import { MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_TW } from './locales/zh-tw/mock-cross-currency.js';

/**
 * @typedef {Object} MockTransaction
 * @property {string} id
 * @property {string} date
 * @property {string} type
 * @property {number} amount
 * @property {string} description
 * @property {string} accountId
 * @property {string} accountName
 * @property {string} currency
 * @property {string} currencySymbol
 * @property {number} currencyDecimalPlaces
 * @property {string} [tagNames]
 * @property {boolean} [isTransferPair]
 * @property {string} [pairedType]
 * @property {number} [pairedAmount]
 * @property {string} [pairedCurrencySymbol]
 * @property {number} [pairedCurrencyDecimalPlaces]
 * @property {string} [pairedAccountName]
 * @property {string} [pairedAccountId]
 * @property {string} [pairedDate]
 */

/** @type {Record<string, Array<MockTransaction>>} */
const TRANSACTIONS = {
	en: MOCK_TRANSACTIONS_EN,
	'en-US': MOCK_TRANSACTIONS_EN_US,
	ja: MOCK_TRANSACTIONS_JA,
	ko: MOCK_TRANSACTIONS_KO,
	'zh-CN': MOCK_TRANSACTIONS_ZH_CN,
	'zh-TW': MOCK_TRANSACTIONS_ZH_TW,
};

/** @type {Record<string, Array<MockTransaction>>} */
const AVIOS = {
	en: MOCK_AVIOS_TRANSACTIONS_EN,
	'en-US': MOCK_AVIOS_TRANSACTIONS_EN_US,
	ja: MOCK_AVIOS_TRANSACTIONS_JA,
	ko: MOCK_AVIOS_TRANSACTIONS_KO,
	'zh-CN': MOCK_AVIOS_TRANSACTIONS_ZH_CN,
	'zh-TW': MOCK_AVIOS_TRANSACTIONS_ZH_TW,
};

/** @type {Record<string, Array<MockTransaction>>} */
const CROSS_CURRENCY = {
	en: MOCK_CROSS_CURRENCY_TRANSACTIONS_EN,
	'en-US': MOCK_CROSS_CURRENCY_TRANSACTIONS_EN_US,
	ja: MOCK_CROSS_CURRENCY_TRANSACTIONS_JA,
	ko: MOCK_CROSS_CURRENCY_TRANSACTIONS_KO,
	'zh-CN': MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_CN,
	'zh-TW': MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_TW,
};

/**
 * @param {string} lang
 * @returns {Array<MockTransaction>}
 */
export function getMockTransactions(lang) {
	return TRANSACTIONS[lang] ?? MOCK_TRANSACTIONS_EN;
}

/**
 * @param {string} lang
 * @returns {Array<MockTransaction>}
 */
export function getMockAviosTransactions(lang) {
	return AVIOS[lang] ?? MOCK_AVIOS_TRANSACTIONS_EN;
}

/**
 * @param {string} lang
 * @returns {Array<MockTransaction>}
 */
export function getMockCrossCurrencyTransactions(lang) {
	return CROSS_CURRENCY[lang] ?? MOCK_CROSS_CURRENCY_TRANSACTIONS_EN;
}
